module.exports = __webpack_public_path__ + "img/index_yewu_icon_chengs.057af6c4.png";